import React from 'react';

export const Title_Modal_Consult = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>CONTACT</span>,
  },
];

export const Title_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>COLLABORATE</span>,
  },
];

export const TitleJoin_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>JOIN THE TEAM</span>,
  },
];

export const TitlePrac_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>INTERNSHIPS / COMMUNITY SERVICE</span>,
  },
];
